import { calendarDayOfWeek_Saturday } from 'owa-locstrings/lib/strings/calendardayofweek_saturday.locstring.json';
import { calendarDayOfWeek_Friday } from 'owa-locstrings/lib/strings/calendardayofweek_friday.locstring.json';
import { calendarDayOfWeek_Thursday } from 'owa-locstrings/lib/strings/calendardayofweek_thursday.locstring.json';
import { calendarDayOfWeek_Wednesday } from 'owa-locstrings/lib/strings/calendardayofweek_wednesday.locstring.json';
import { calendarDayOfWeek_Tuesday } from 'owa-locstrings/lib/strings/calendardayofweek_tuesday.locstring.json';
import { calendarDayOfWeek_Monday } from 'owa-locstrings/lib/strings/calendardayofweek_monday.locstring.json';
import { calendarDayOfWeek_Sunday } from 'owa-locstrings/lib/strings/calendardayofweek_sunday.locstring.json';
import { getCalendarStrings } from 'owa-datepicker-common';
import loc from 'owa-localize';

export const getWeekdayNames = (): string[] => [
    loc(calendarDayOfWeek_Sunday),
    loc(calendarDayOfWeek_Monday),
    loc(calendarDayOfWeek_Tuesday),
    loc(calendarDayOfWeek_Wednesday),
    loc(calendarDayOfWeek_Thursday),
    loc(calendarDayOfWeek_Friday),
    loc(calendarDayOfWeek_Saturday),
];

export const getShortWeekdayNames = (): string[] => [
    getCalendarStrings().shortDays[0],
    getCalendarStrings().shortDays[1],
    getCalendarStrings().shortDays[2],
    getCalendarStrings().shortDays[3],
    getCalendarStrings().shortDays[4],
    getCalendarStrings().shortDays[5],
    getCalendarStrings().shortDays[6],
];

export const DEFAULT_START_TIME: number = 0 * 60;
export const DEFAULT_END_TIME: number = 24 * 60;
export const DEFAULT_TIME_INTERVAL = 15;
export const DEFAULT_BUSINESS_START_TIME: number = 8 * 60;
export const DEFAULT_BUSINESS_END_TIME: number = 17 * 60;
